<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    :style="{ height: '78vh' }"
  >
    <div class="station-popup">
      <div class="station-popup__search">
        <van-search
          v-model="keyword"
          placeholder="请输入站点名称搜索"
          clear-trigger="always"
        />
      </div>

      <div class="station-popup__list">
        <div v-if="loading" class="station-popup__empty">加载站点中...</div>
        <div v-else-if="!displayList.length" class="station-popup__empty">
          暂无站点数据
        </div>
        <van-cell
          v-for="item in displayList"
          :key="item.NodeGID"
          :title="item.NodeName"
          is-link
          class="station-cell"
          @click="onSelect(item)"
        >
          <template #icon>
            <div
              class="station-cell__favorite"
              @click.stop="onToggleFavorite(item)"
            >
              <van-icon
                :name="isCollected(item.NodeGID) ? 'star' : 'star-o'"
                :color="isCollected(item.NodeGID) ? '#ff9900' : '#ccc'"
                size="20"
              />
            </div>
          </template>
        </van-cell>
      </div>

      <div class="station-popup__footer">
        <van-button block plain type="danger" hairline @click="visible = false">
          取消
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {
  filterStationsByKeyword,
  sortStationsWithCollect,
} from "../node-check-utils";

export default {
  name: "StationSelectPopup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    nodeList: {
      type: Array,
      default: () => [],
    },
    collectNodeList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyword: "",
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    displayList() {
      const filtered = filterStationsByKeyword(this.nodeList, this.keyword);
      return sortStationsWithCollect(filtered, this.collectNodeList);
    },
  },
  watch: {
    value(show) {
      if (!show) this.keyword = "";
    },
  },
  methods: {
    isCollected(nodeGID) {
      return this.collectNodeList.some((item) => item.NodeGID === nodeGID);
    },
    onSelect(item) {
      this.$emit("select", item);
      this.visible = false;
    },
    onToggleFavorite(item) {
      if (this.isCollected(item.NodeGID)) {
        this.$emit("remove-collect", item);
      } else {
        this.$emit("collect", item);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.station-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
}

.station-popup__search {
  flex-shrink: 0;
  padding: 0.2rem 0.2rem 0;
}

.station-popup__list {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.station-popup__empty {
  padding: 1rem 0;
  text-align: center;
  color: #999;
  font-size: 0.38rem;
}

.station-cell {
  text-align: left;

  &__favorite {
    display: flex;
    align-items: center;
    margin-right: 0.2rem;
    padding: 0.1rem;
  }
}

.station-popup__footer {
  flex-shrink: 0;
  padding: 0.2rem;
  border-top: 1px solid #f0f0f0;
}
</style>
